<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">

        <span class="reels-title">
          <i class="fa fa-img"></i> Lista de Reels
        </span>
        <div *ngIf="isAdmin" class="filter-actions">
          <p-dropdown
            [options]="clientes"
            optionLabel="nombre_comercial"
            optionValue="id"
            [(ngModel)]="selectedClientId"
            (ngModelChange)="onClientChange()"
            styleClass="p-dropdown-sm"
            [filter]="true"
            placeholder="Selecciona un cliente"
          ></p-dropdown>

          <button
            *ngIf="selectedClientId"
            type="button"
            class="btn btn-sm btn-outline-secondary btn-clear"
            (click)="clearClientFilter()"
            title="Quitar filtro"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div *ngIf="canAddGroup" class="btn-add-container" >
          <button class="btn btn-primary btn-add" (click)="add()">
            <i class="fa fa-plus-square"></i>
            Agregar Reel
          </button>
        </div>
      </div>

      <div class="card-body">
        <app-datatable [options]="dtConfig"></app-datatable>
      </div>
    </div>
  </div>
</div>
